import { ITask } from "../../services";

class TaskArchiveController implements ng.IComponentController {
    private sortType: string;
    private search: string;
    private tasks: ITask[];
    private filteredTasks: ITask[];
    private selectedStatus: string;

    constructor(private $filter: any) {
        'ngInject';
    }

    public $onInit = () => {
        this.sortType = 'date';
        this.filter();
    }

    filter() {
        this.filteredTasks = this.$filter('filterBy')(this.tasks, ['taskStatusName'], this.selectedStatus);
    }
}

export const taskArchiveComponent = {
    bindings: {
        tasks: '<',
        taskStatuses: '<'
    },
    controller: TaskArchiveController,
    template: require('./task.archive.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/tasks/task.archive.component.ts